import { sortBy } from 'lodash';

import useProject from '@API/project/useProject';
import useProjectViews from '@API/project/useProjectViews';
import { useGenerateUnsavedViewId } from '@API/project/useGenerateUnsavedViewTemplateId';
import { ViewItemData } from '@shared/components/ViewSelect/utils';
import {
  templateToProjectOptionItem,
  templateToWorkspaceOptionItem
} from '../utils';

const useDashboardViewOptions = () => {
  const { data: templates = [] } = useProjectViews();
  const { data: project } = useProject();
  const unsavedTemplateId = useGenerateUnsavedViewId();

  const preparedTemplates = templates.filter(
    template =>
      template.templateId &&
      !template.unsavedView &&
      !(template.templateId === unsavedTemplateId)
  );

  const projectViewList: ViewItemData[] = preparedTemplates
    .filter(template => template.projectId === project?.projectId)
    .map(templateToProjectOptionItem);
  const workspaceViewList: ViewItemData[] = preparedTemplates
    .filter(template => template.projectId !== project?.projectId)
    .map(templateToWorkspaceOptionItem);

  return {
    projectViewList: sortBy(projectViewList, 'name'),
    workspaceViewList: sortBy(workspaceViewList, 'name')
  };
};

export default useDashboardViewOptions;
